import config from '../config';

/**
 * The one place the client event mirror's URL is spelled.
 *
 * Two modules need it and neither may import the other: `eventMirror` POSTs to
 * it, and `monitoring` filters it out of Sentry's breadcrumb ring (a flush
 * every 5s against a 100-breadcrumb cap evicts the user actions that caused an
 * error within about eight minutes). `eventMirror` already imports `monitoring`
 * to report flush failures, so having `monitoring` import `eventMirror` back is
 * a cycle — under CRA's Babel transform the late-initialised binding is
 * `undefined` at module-evaluation time, which fails as
 * `eventMirrorEndpoint is not a function` in twelve suites rather than as
 * anything resembling an import error.
 *
 * Hence a third module that imports neither. Built as a function rather than a
 * const because `config.baseURL` is read at call time in the tests that
 * override it.
 */
export const eventMirrorEndpoint = (): string => `${config.baseURL}/api/v1/events`;
